import { useField, useFormikContext } from 'formik';
import { type FC } from 'react';

import { ODSPasswordField } from '../../InputFields';

interface FormikPasswordFieldProps {
  name: string;
  label: string;
  placeholder?: string;
  disabled?: boolean | string;
}

export const FormikPasswordField: FC<FormikPasswordFieldProps> = ({
  name,
  label,
  placeholder = '',
  disabled = false,
}) => {
  const [field, meta] = useField(name);
  const { values } = useFormikContext<Record<string, unknown>>();
  const isDisabled = typeof disabled === 'string' ? !values[disabled] : disabled;

  return (
    <ODSPasswordField
      id={field.name}
      name={field.name}
      value={field.value as string}
      onChange={field.onChange}
      onBlur={field.onBlur}
      label={label}
      placeholder={placeholder}
      disabled={isDisabled}
      {...(meta.touched && { helperText: meta.error })}
    />
  );
};
